import appStoreAppOfTheYear2023White from "@assets/app_store_app_of_the_day_2023_white.webp"
import googleEditorsChoice2023White from "@assets/google_editors_choice_2023_white.webp"
import AnimatedEmoji from "@components/AnimatedEmoji"
import ContinuePage from "@components/ContinuePage"
import { motion } from "framer-motion"
import { useTranslation } from "react-i18next"

const BADGES = [
  { src: appStoreAppOfTheYear2023White, altKey: "appStoreAppOfTheYear2023" },
  { src: googleEditorsChoice2023White, altKey: "googleEditorsChoice2023" },
]

export default function CompanyPage() {
  const { t } = useTranslation()

  return (
    <ContinuePage translationKey="company">
      <div className="flex grow flex-col items-center justify-center space-y-8 text-center">
        <AnimatedEmoji emoji="🏆" />

        <h1 className="heading">{t("pages.onboarding.company.heading")}</h1>

        <div className="flex items-center justify-center gap-4">
          {BADGES.map((badge, i) => (
            <motion.img
              key={badge.altKey}
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: i * 0.15 }}
              alt={t(`pages.onboarding.company.${badge.altKey}`)}
              className="w-32"
              src={badge.src}
            />
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.4, delay: 0.35 }}
          className="rounded-2xl bg-white/5 px-8 py-5"
        >
          <p className="text-text-secondary text-sm">
            {t("pages.onboarding.company.andHas")}
          </p>
          <p className="heading mt-1">
            {t("pages.onboarding.company.activeSubscribers")}
          </p>
        </motion.div>
      </div>
    </ContinuePage>
  )
}
